export default __webpack_public_path__ + "static/Invest_in_Pomerania-06bc74bfdeea7a892efc7339fa7c83ad.png";